// src/components/Navbar.jsx
//
// Same structure as the AFSC reference (brand, nav links with
// active-link highlighting, username + logout on the right) -- just
// swapped in the tracker's own pages in place of AFSC's Tasks/Admin/
// Overview, and no admin-only links yet since the dashboard endpoints
// are open to any authenticated user right now, not admin-gated.

import { Link, useLocation, useNavigate } from "react-router-dom";

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const username = localStorage.getItem("username");

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("username");
    localStorage.removeItem("role");
    navigate("/login");
  };

  const isActive = (path) =>
    location.pathname === path || location.pathname.startsWith(path + "/");

  return (
    <nav className="app-nav">
      <div className="app-nav-inner">
        <div className="app-nav-brand">
          <span className="brand-mark" />
          WH Project Tracker
        </div>
        <div className="app-nav-links">
          <Link className={isActive("/projects") ? "active" : ""} to="/projects">
            Projects
          </Link>
          <Link
            className={location.pathname === "/dashboard" ? "active" : ""}
            to="/dashboard"
          >
            Dashboard
          </Link>
          <Link className={isActive("/dashboard/mine") ? "active" : ""} to="/dashboard/mine">
            My dashboard
          </Link>
          <Link className={isActive("/import-export") ? "active" : ""} to="/import-export">
            Import / export
          </Link>
        </div>
        <div className="app-nav-right">
          {username && <span className="app-nav-user">{username}</span>}
          <button onClick={handleLogout}>Log out</button>
        </div>
      </div>
    </nav>
  );
}
